module.exports = __webpack_public_path__ + "static/media/step2-active.64399468.svg";